type LeaveAttemptHandler = (proceed: () => void) => void;

type NavigationLeaveGate = {
  shouldBlock: () => boolean;
  onAttempt: LeaveAttemptHandler;
};

let activeGate: NavigationLeaveGate | null = null;

/** Register a leave gate (e.g. dirty draft editor). Returns unregister. */
export function registerNavigationLeaveGate(
  gate: NavigationLeaveGate,
): () => void {
  activeGate = gate;
  return () => {
    if (activeGate === gate) {
      activeGate = null;
    }
  };
}

/** True when a registered gate would block navigation. */
export function isNavigationLeaveBlocked(): boolean {
  return Boolean(activeGate?.shouldBlock());
}

/**
 * If a leave gate is active, invoke it with `proceed` and return true (blocked).
 * Otherwise run `proceed` immediately and return false.
 */
export function runWithNavigationLeaveGate(proceed: () => void): boolean {
  if (!activeGate?.shouldBlock()) {
    proceed();
    return false;
  }
  activeGate.onAttempt(proceed);
  return true;
}
